/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationPipelineConfigShowPathParams,
	OrganisationPipelineConfigShowResponse,
} from '../types/OrganisationPipelineConfigShow'

/**
 * GET /organisations/:organisation/pipeline-config
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationPipelineConfigController.php OrganisationPipelineConfigController::show
 */
export async function organisationPipelineConfigShow(
	organisation: OrganisationPipelineConfigShowPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationPipelineConfigShowResponse>> {
	return axiosInstance.get(`/organisations/${organisation}/pipeline-config`, config)
}
